/**
 * Accepts only same-origin relative paths as post-login destinations.
 * Anything else (absolute URLs, protocol-relative "//", backslashes, control
 * characters, script schemes) falls back to the members area — prevents
 * open redirects (CWE-601).
 */
export const DEFAULT_RETURN_PATH = "/members";

export function safeReturnPath(value: unknown): string {
  if (typeof value !== "string" || value.length === 0 || value.length > 512) {
    return DEFAULT_RETURN_PATH;
  }
  if (!value.startsWith("/") || value.startsWith("//") || value.includes("\\")) {
    return DEFAULT_RETURN_PATH;
  }
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f]/.test(value)) return DEFAULT_RETURN_PATH;
  if (value === "/auth" || value.startsWith("/auth?") || value.startsWith("/auth#")) {
    return DEFAULT_RETURN_PATH;
  }
  try {
    const parsed = new URL(value, "https://foreign-council.org");
    if (parsed.origin !== "https://foreign-council.org") return DEFAULT_RETURN_PATH;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return DEFAULT_RETURN_PATH;
  }
}
